import Bell, { BellConstructorConfig } from './Bell';
import builtinBells from './builtinBells';
import { CustomizedShowArrType } from '../../api/define';
import store from '../../store';

/**
 * 🔔 铃声服务
 *
 * 提供以下能力：
 *
 * 1. 铃声注册
 * 2. 铃声播放（优先级控制）
 * 3. 注册默认铃声
 */

const bellCache: {
    [key: string]: Bell;
} = {};

/**
 * 注册一个新铃声
 */
const registerBell = (config: BellConstructorConfig) => {
    // 避免同一个铃声重复注册
    if (!bellCache[config.key]) {
        const bell = new Bell(config);
        bellCache[config.key] = bell;
    }
};

let currentBell: Bell | null = null;

/** 播放铃声 */
const playBell = (key: string) => {
    const customizedShowArr = store.getState().shellCommon.customizedShowArr;
    const hidePushForXBK = customizedShowArr.includes(CustomizedShowArrType.PUSH_MESSAGE);

    if (hidePushForXBK) {
        return;
    }

    const nextBell: Bell | null = bellCache[key] || null;

    if (nextBell === null) {
        return;
    }

    if (currentBell && currentBell.isPalying()) {
        if (nextBell.priority <= currentBell.priority && nextBell.key !== currentBell.key) {
            // 新来的铃声优先级更高
            currentBell.stop();
            nextBell.play();
            currentBell = nextBell;
        }
    } else {
        // 当前没有播放中的铃声
        nextBell.play();
        currentBell = nextBell;
    }
};

/**
 * 初始化内置铃声
 */
const registerBuiltinBells = () => {
    builtinBells.forEach(registerBell);

    /** TODO: FIXME: 兼容 IM/自动接单 直接通过 parent 访问 audioControl 的场景，待全量后修改 IM 调用方式 */
    window.audioControls = {
        'message-remind1': {
            audioPlay: () => playBell('message-remind1'),
            audioStop: () => null,
        },
        'new-message': {
            audioPlay: () => playBell('new-message'),
            audioStop: () => null,
        },
        autoAcceptDisconnect: {
            audioPlay: () => playBell('autoAcceptDisconnect'),
            audioStop: () => null,
        },
    };
};

const bellService = {
    playBell,
    registerBell,
    registerBuiltinBells,
};

export default bellService;
